// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Phases_pad {
        padding: 20px;
        height: 100%;

        min-width: 0;
        background-color: #f5f5f5;
}

.Phases_container {
        display: flex;
        flex-direction: column;

        height: 100%;
        max-height: 100%;
        overflow: hidden;

        min-width: 0;

        border: 1px solid #ddd;
        border-radius: 12px;
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.Phases_row_1 {
        display: flex;
        overflow: auto;
        /* height: 55%;
        max-height: 55%; */
        height: 100%;
        flex-wrap: wrap;
        background-color: #ffffff;
}

.Phases_phasesContainer {
        display: flex;
        flex-grow: 1;
        padding: 20px 30px;
        overflow: hidden;
}

.Phases_wrapperDiv {
        width: 100%;

        display: flex;
        flex-direction: column;
}

.Phases_title {
        display: flex;
        font-family: "Montserrat";
        font-size: 20px;
        font-weight: 600;
        /* margin-top: -17px; */
}

.Phases_phases {
        display: flex;
        flex-direction: column;
        flex-grow: 1;
}

.Phases_wrapperRow {
        margin-top: 20px;

        /* height: 100%; */
        display: flex;
        flex-wrap: wrap;
}

.Phases_row_2 {
        display: flex;
        flex-direction: column;
        overflow: hidden;
        height: 45%;
        max-height: 45%;
        width: 100%;
        max-width: 100%;
        margin-top: 20px;

        background-color: #fff;
        border: 1px solid #e4e4e4;
        padding: 20px;

        min-width: 0;
}

.Phases_row_2_content {
        margin-top: 20px;
        display: flex;
        flex-grow: 1;
        overflow: hidden;

        min-width: 0;
}

.Phases_row_2_contentCol1 {
        display: flex;
        flex-direction: column;
        height: 100%;
        width: 200px;
        flex-shrink: 0;
}

.Phases_selectedDocument {
        font-family: "Montserrat";
        font-size: 12px;
        font-weight: 600;

        display: flex;
        border: 1px solid #e4e4e4;
        align-items: center;
        justify-content: space-between;

        width: 100%;
        padding: 10px 15px;

        cursor: pointer;
}
.Phases_selectedDocument.setup {
        margin-top: 5px;
}

.Phases_selectedDocumentDropdown {
        height: 5px;
}
.Phases_selectedDocumentDropdown.show {
        transform: scaleY(-1);
}

.Phases_documentOptions.show {
        margin-top: 10px;
        border: 1px solid #e4e4e4;
        display: flex;
        flex-direction: column;
        width: 100%;
        overflow-y: auto;
}
.Phases_documentOptions.show.setup {
        z-index: 1;
        position: relative;
}

.Phases_documentOptions.hide {
        display: none;
}

.Phases_documentOption {
        display: flex;
        flex-shrink: 0;
        align-items: center;

        font-family: "Montserrat";
        font-size: 12px;

        padding: 10px 15px;

        cursor: pointer;
}

.Phases_documentOption:last-child {
        margin-bottom: 0;
}

.Phases_documentOption:hover {
        background-color: #f3f3f3ec;
}

.Phases_row_2_contentCol2 {
        display: flex;
        flex-shrink: 0;
        flex-direction: column;
        height: 100%;
        width: 400px;
        margin-left: 20px;
}

.Phases_history {
        display: flex;
        flex-direction: column;

        border: 1px solid #e4e4e4;

        height: 100%;
}

.Phases_historyRecord {
        height: 40px;
        font-family: "Montserrat";
        font-size: 12px;

        display: flex;
        align-items: center;

        cursor: pointer;
}
.Phases_historyRecord.selected {
        font-weight: 600;
}
.Phases_historyRecord:hover {
        background-color: #f3f3f3ec;
}

.Phases_historyNoRecord {
        margin-top: 10px;
        margin-left: 20px;
        font-family: "Montserrat";
        font-size: 14px;
        opacity: 0.8;
}

.Phases_historyRecord_index {
        display: flex;
        padding: 10px 20px;
        align-items: center;
        width: 40px;
}

.Phases_historyRecord_fileName {
        padding: 10px 5px;
}

.Phases_row_2_contentCol3 {
        display: flex;
        flex-direction: column;
        height: 100%;
        flex-grow: 1;
        margin-left: 20px;
        font-family: "Montserrat";
        font-size: 12px;

        min-width: 0;

        border: 1px solid #e4e4e4;
}

.Phases_previewQuestion {
        display: flex;

        font-weight: 600;
        min-height: 40px;
        min-width: 0;
        white-space: nowrap;
        text-wrap: nowrap;
        padding: 10px 15px;
        overflow: hidden;

        position: relative;
}

.Phases_fade {
        display: flex;
        position: absolute;
        z-index: 1;
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
        background: linear-gradient(to right, rgba(255, 255, 255, 0) 0% 90%, #fff 97% 100%);
}

.Phases_previewAnswer {
        display: flex;
        width: 100%;
        min-width: 0;
        padding: 10px 15px;

        overflow-y: auto;
}

.Phases_documentPreview {
        display: flex;
        flex-direction: column;
        flex-grow: 1;
        overflow: hidden;
        border: 1px solid #e4e4e4;

        min-width: 0;
}



`, "",{"version":3,"sources":["webpack://./src/screens/Phases/Phases.css"],"names":[],"mappings":"AAAA;QACQ,aAAa;QACb,YAAY;;QAEZ,YAAY;QACZ,yBAAyB;AACjC;;AAEA;QACQ,aAAa;QACb,sBAAsB;;QAEtB,YAAY;QACZ,gBAAgB;QAChB,gBAAgB;;QAEhB,YAAY;;QAEZ,sBAAsB;QACtB,mBAAmB;QACnB,wCAAwC;AAChD;;AAEA;QACQ,aAAa;QACb,cAAc;QACd;0BACkB;QAClB,YAAY;QACZ,eAAe;QACf,yBAAyB;AACjC;;AAEA;QACQ,aAAa;QACb,YAAY;QACZ,kBAAkB;QAClB,gBAAgB;AACxB;;AAEA;QACQ,WAAW;;QAEX,aAAa;QACb,sBAAsB;AAC9B;;AAEA;QACQ,aAAa;QACb,yBAAyB;QACzB,eAAe;QACf,gBAAgB;QAChB,uBAAuB;AAC/B;;AAEA;QACQ,aAAa;QACb,sBAAsB;QACtB,YAAY;AACpB;;AAEA;QACQ,gBAAgB;;QAEhB,kBAAkB;QAClB,aAAa;QACb,eAAe;AACvB;;AAEA;QACQ,aAAa;QACb,sBAAsB;QACtB,gBAAgB;QAChB,WAAW;QACX,eAAe;QACf,WAAW;QACX,eAAe;QACf,gBAAgB;;QAEhB,sBAAsB;QACtB,yBAAyB;QACzB,aAAa;;QAEb,YAAY;AACpB;;AAEA;QACQ,gBAAgB;QAChB,aAAa;QACb,YAAY;QACZ,gBAAgB;;QAEhB,YAAY;AACpB;;AAEA;QACQ,aAAa;QACb,sBAAsB;QACtB,YAAY;QACZ,YAAY;QACZ,cAAc;AACtB;;AAEA;QACQ,yBAAyB;QACzB,eAAe;QACf,gBAAgB;;QAEhB,aAAa;QACb,yBAAyB;QACzB,mBAAmB;QACnB,8BAA8B;;QAE9B,WAAW;QACX,kBAAkB;;QAElB,eAAe;AACvB;AACA;QACQ,eAAe;AACvB;;AAEA;QACQ,WAAW;AACnB;AACA;QACQ,qBAAqB;AAC7B;;AAEA;QACQ,gBAAgB;QAChB,yBAAyB;QACzB,aAAa;QACb,sBAAsB;QACtB,WAAW;QACX,gBAAgB;AACxB;AACA;QACQ,UAAU;QACV,kBAAkB;AAC1B;;AAEA;QACQ,aAAa;AACrB;;AAEA;QACQ,aAAa;QACb,cAAc;QACd,mBAAmB;;QAEnB,yBAAyB;QACzB,eAAe;;QAEf,kBAAkB;;QAElB,eAAe;AACvB;;AAEA;QACQ,gBAAgB;AACxB;;AAEA;QACQ,2BAA2B;AACnC;;AAEA;QACQ,aAAa;QACb,cAAc;QACd,sBAAsB;QACtB,YAAY;QACZ,YAAY;QACZ,iBAAiB;AACzB;;AAEA;QACQ,aAAa;QACb,sBAAsB;;QAEtB,yBAAyB;;QAEzB,YAAY;AACpB;;AAEA;QACQ,YAAY;QACZ,yBAAyB;QACzB,eAAe;;QAEf,aAAa;QACb,mBAAmB;;QAEnB,eAAe;AACvB;AACA;QACQ,gBAAgB;AACxB;AACA;QACQ,2BAA2B;AACnC;;AAEA;QACQ,gBAAgB;QAChB,iBAAiB;QACjB,yBAAyB;QACzB,eAAe;QACf,YAAY;AACpB;;AAEA;QACQ,aAAa;QACb,kBAAkB;QAClB,mBAAmB;QACnB,WAAW;AACnB;;AAEA;QACQ,iBAAiB;AACzB;;AAEA;QACQ,aAAa;QACb,sBAAsB;QACtB,YAAY;QACZ,YAAY;QACZ,iBAAiB;QACjB,yBAAyB;QACzB,eAAe;;QAEf,YAAY;;QAEZ,yBAAyB;AACjC;;AAEA;QACQ,aAAa;;QAEb,gBAAgB;QAChB,gBAAgB;QAChB,YAAY;QACZ,mBAAmB;QACnB,iBAAiB;QACjB,kBAAkB;QAClB,gBAAgB;;QAEhB,kBAAkB;AAC1B;;AAEA;QACQ,aAAa;QACb,kBAAkB;QAClB,UAAU;QACV,MAAM;QACN,OAAO;QACP,YAAY;QACZ,WAAW;QACX,mFAAmF;AAC3F;;AAEA;QACQ,aAAa;QACb,WAAW;QACX,YAAY;QACZ,kBAAkB;;QAElB,gBAAgB;AACxB;;AAEA;QACQ,aAAa;QACb,sBAAsB;QACtB,YAAY;QACZ,gBAAgB;QAChB,yBAAyB;;QAEzB,YAAY;AACpB","sourcesContent":[".Phases_pad {\n        padding: 20px;\n        height: 100%;\n\n        min-width: 0;\n        background-color: #f5f5f5;\n}\n\n.Phases_container {\n        display: flex;\n        flex-direction: column;\n\n        height: 100%;\n        max-height: 100%;\n        overflow: hidden;\n\n        min-width: 0;\n\n        border: 1px solid #ddd;\n        border-radius: 12px;\n        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n}\n\n.Phases_row_1 {\n        display: flex;\n        overflow: auto;\n        /* height: 55%;\n        max-height: 55%; */\n        height: 100%;\n        flex-wrap: wrap;\n        background-color: #ffffff;\n}\n\n.Phases_phasesContainer {\n        display: flex;\n        flex-grow: 1;\n        padding: 20px 30px;\n        overflow: hidden;\n}\n\n.Phases_wrapperDiv {\n        width: 100%;\n\n        display: flex;\n        flex-direction: column;\n}\n\n.Phases_title {\n        display: flex;\n        font-family: \"Montserrat\";\n        font-size: 20px;\n        font-weight: 600;\n        /* margin-top: -17px; */\n}\n\n.Phases_phases {\n        display: flex;\n        flex-direction: column;\n        flex-grow: 1;\n}\n\n.Phases_wrapperRow {\n        margin-top: 20px;\n\n        /* height: 100%; */\n        display: flex;\n        flex-wrap: wrap;\n}\n\n.Phases_row_2 {\n        display: flex;\n        flex-direction: column;\n        overflow: hidden;\n        height: 45%;\n        max-height: 45%;\n        width: 100%;\n        max-width: 100%;\n        margin-top: 20px;\n\n        background-color: #fff;\n        border: 1px solid #e4e4e4;\n        padding: 20px;\n\n        min-width: 0;\n}\n\n.Phases_row_2_content {\n        margin-top: 20px;\n        display: flex;\n        flex-grow: 1;\n        overflow: hidden;\n\n        min-width: 0;\n}\n\n.Phases_row_2_contentCol1 {\n        display: flex;\n        flex-direction: column;\n        height: 100%;\n        width: 200px;\n        flex-shrink: 0;\n}\n\n.Phases_selectedDocument {\n        font-family: \"Montserrat\";\n        font-size: 12px;\n        font-weight: 600;\n\n        display: flex;\n        border: 1px solid #e4e4e4;\n        align-items: center;\n        justify-content: space-between;\n\n        width: 100%;\n        padding: 10px 15px;\n\n        cursor: pointer;\n}\n.Phases_selectedDocument.setup {\n        margin-top: 5px;\n}\n\n.Phases_selectedDocumentDropdown {\n        height: 5px;\n}\n.Phases_selectedDocumentDropdown.show {\n        transform: scaleY(-1);\n}\n\n.Phases_documentOptions.show {\n        margin-top: 10px;\n        border: 1px solid #e4e4e4;\n        display: flex;\n        flex-direction: column;\n        width: 100%;\n        overflow-y: auto;\n}\n.Phases_documentOptions.show.setup {\n        z-index: 1;\n        position: relative;\n}\n\n.Phases_documentOptions.hide {\n        display: none;\n}\n\n.Phases_documentOption {\n        display: flex;\n        flex-shrink: 0;\n        align-items: center;\n\n        font-family: \"Montserrat\";\n        font-size: 12px;\n\n        padding: 10px 15px;\n\n        cursor: pointer;\n}\n\n.Phases_documentOption:last-child {\n        margin-bottom: 0;\n}\n\n.Phases_documentOption:hover {\n        background-color: #f3f3f3ec;\n}\n\n.Phases_row_2_contentCol2 {\n        display: flex;\n        flex-shrink: 0;\n        flex-direction: column;\n        height: 100%;\n        width: 400px;\n        margin-left: 20px;\n}\n\n.Phases_history {\n        display: flex;\n        flex-direction: column;\n\n        border: 1px solid #e4e4e4;\n\n        height: 100%;\n}\n\n.Phases_historyRecord {\n        height: 40px;\n        font-family: \"Montserrat\";\n        font-size: 12px;\n\n        display: flex;\n        align-items: center;\n\n        cursor: pointer;\n}\n.Phases_historyRecord.selected {\n        font-weight: 600;\n}\n.Phases_historyRecord:hover {\n        background-color: #f3f3f3ec;\n}\n\n.Phases_historyNoRecord {\n        margin-top: 10px;\n        margin-left: 20px;\n        font-family: \"Montserrat\";\n        font-size: 14px;\n        opacity: 0.8;\n}\n\n.Phases_historyRecord_index {\n        display: flex;\n        padding: 10px 20px;\n        align-items: center;\n        width: 40px;\n}\n\n.Phases_historyRecord_fileName {\n        padding: 10px 5px;\n}\n\n.Phases_row_2_contentCol3 {\n        display: flex;\n        flex-direction: column;\n        height: 100%;\n        flex-grow: 1;\n        margin-left: 20px;\n        font-family: \"Montserrat\";\n        font-size: 12px;\n\n        min-width: 0;\n\n        border: 1px solid #e4e4e4;\n}\n\n.Phases_previewQuestion {\n        display: flex;\n\n        font-weight: 600;\n        min-height: 40px;\n        min-width: 0;\n        white-space: nowrap;\n        text-wrap: nowrap;\n        padding: 10px 15px;\n        overflow: hidden;\n\n        position: relative;\n}\n\n.Phases_fade {\n        display: flex;\n        position: absolute;\n        z-index: 1;\n        top: 0;\n        left: 0;\n        height: 100%;\n        width: 100%;\n        background: linear-gradient(to right, rgba(255, 255, 255, 0) 0% 90%, #fff 97% 100%);\n}\n\n.Phases_previewAnswer {\n        display: flex;\n        width: 100%;\n        min-width: 0;\n        padding: 10px 15px;\n\n        overflow-y: auto;\n}\n\n.Phases_documentPreview {\n        display: flex;\n        flex-direction: column;\n        flex-grow: 1;\n        overflow: hidden;\n        border: 1px solid #e4e4e4;\n\n        min-width: 0;\n}\n\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
